import { invariant } from '@mimir/common/util/invariant';
import type { OpaqueRefCountedBuffer, VideoFrameV2 } from '@mimir/cutter/frameProvider/frameProvider';

export function makeOpaqueRefCountedBuffer(bufferSize: number, videoFrame: VideoFrame, state: { refCount: number }): OpaqueRefCountedBuffer & { internalVideoFrame: VideoFrame } {
  state.refCount ++;
  let closed = false;
  return {
    async copyTo(bytes: Uint8Array): Promise<void> {
      invariant(!closed, 'Buffer is closed');
      await videoFrame.copyTo(bytes, { });
    },
    close(): void {
      invariant(!closed, 'Buffer is closed');
      state.refCount --;
      if (state.refCount === 0) {
        videoFrame.close();
      }
    },
    addReference(): OpaqueRefCountedBuffer {
      return makeOpaqueRefCountedBuffer(bufferSize, videoFrame, state);
    },
    size(): number {
      invariant(!closed, 'Buffer is closed');
      return bufferSize;
    },
    internalVideoFrame: videoFrame,
  }
}

export function getInternalVideoFrame(videoFrame: VideoFrameV2): VideoFrame | null {
  const bufferWithVideoFrame : OpaqueRefCountedBuffer & { internalVideoFrame?: VideoFrame } = videoFrame.buffer;
  return bufferWithVideoFrame.internalVideoFrame ?? null;
}
